__turbopack_context__.v({
  "current": "styles-module-scss-module__lcfc3W__current",
  "ownership": "styles-module-scss-module__lcfc3W__ownership",
  "refinance": "styles-module-scss-module__lcfc3W__refinance",
  "rental": "styles-module-scss-module__lcfc3W__rental",
  "tooltip": "styles-module-scss-module__lcfc3W__tooltip",
  "tooltip_header": "styles-module-scss-module__lcfc3W__tooltip_header",
  "tooltip_label": "styles-module-scss-module__lcfc3W__tooltip_label",
  "tooltip_row": "styles-module-scss-module__lcfc3W__tooltip_row",
  "tooltip_summary": "styles-module-scss-module__lcfc3W__tooltip_summary",
});
